var exports = {
  "iE": "xcc377c0b--285048--wrapper",
  "wx": "xcc377c0b--285048--header",
  "Qs": "xcc377c0b--285048--content",
  "nf": "xcc377c0b--285048--link",
  "qr": "xcc377c0b--285048--footer",
};

module.exports = exports;
